import { Link } from "react-router-dom";
import { useClientAuth } from "../contexts/ClientAuthContext";
import { GoogleLogo } from "@phosphor-icons/react";

export default function ClientLoginPage() {
  const { loginWithGoogle } = useClientAuth();

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] bg-[radial-gradient(circle_at_80%_20%,#D4AF37,transparent_50%)]" />
      <div className="w-full max-w-sm relative z-10 text-center">
        <Link to="/" className="flex justify-center mb-10" data-testid="client-login-brand-link">
          <img
            src="https://customer-assets-0z36b82j.emergentagent.net/job_existfit-portal/artifacts/c41920wx_ExistFitLogo.webp"
            alt="Exist Fit"
            className="h-12 w-auto"
          />
        </Link>
        <div className="bg-[#141414] border border-[#27272A] rounded-2xl p-10">
          <p className="font-heading uppercase tracking-[0.2em] text-xs text-[#A1A1AA] mb-1">Client Hub</p>
          <h1 className="font-heading text-3xl text-white tracking-tight mb-8">Welcome Back</h1>
          <button
            onClick={loginWithGoogle}
            data-testid="client-login-google-button"
            className="w-full flex items-center justify-center gap-3 bg-white text-black rounded-full py-3 font-semibold tracking-wide hover:bg-[#eee] transition-colors"
          >
            <GoogleLogo size={20} weight="bold" />
            Continue with Google
          </button>
          <p className="text-xs text-[#71717A] mt-6 leading-relaxed">
            Your daily workouts, habit tracker and coach messages, all in one place.
          </p>
        </div>
      </div>
    </div>
  );
}
